import gql from 'graphql-tag';
import FieldsTimeslotKindException from 'graphql/fields/FieldsTimeslotKindException'
import FieldsTimeslotKind from 'graphql/fields/FieldsTimeslotKind'

export default gql(`
	query timeslot_kind_exception( $guid: String! ) {
		timeslot_kind_exception( guid: $guid ) {
			${ FieldsTimeslotKindException }
			
			timeslot_kind {
				${FieldsTimeslotKind}
			}
		}
	}
`);

